import React from 'react';

import FadeIn from 'legacy/common/components/transition/FadeIn';

import MomentSettings from './settings/MomentSettings';
import MaxTicketsSettings from './settings/MaxTicketsSettings';
import GuestQuestionSetting from './settings/GuestQuestionSetting';
import TaxSettings from './settings/TaxSettings';
import TrackingLinksSettings from './settings/TrackingLinksSettings';
import WaiverSetting from './settings/WaiverSetting';
import DiscountCodesSettings from './settings/DiscountCodesSettings';
import EventOrganizerFee from './settings/EventOrganizerfee';
import { Event } from 'legacy/common/types/models';
import DangerZone from './settings/DangerZone';
import MetaPixelSettings from './settings/MetaPixelSettings';
import MaxCapacitySettings from './settings/MaxCapacitySettings';
import OffersSettings from './settings/OffersSettings';
import { OffersStep } from 'legacy/events/offers.types';

interface EventSettingsProps {
  eventId: string;
  navigateToTrackingLinks: () => void;
  navigateToDiscountCodes: () => void;
  navigateToSeriesSettings: () => void;
  navigateToOffers: () => void;
  refetchEvent: () => void;
  createDraft: (values?: any) => Promise<Event>;
  setOffersStep: (step: OffersStep) => void;
}

const EventSettings: React.FC<EventSettingsProps> = ({
  eventId,
  navigateToTrackingLinks,
  navigateToDiscountCodes,
  navigateToSeriesSettings,
  navigateToOffers,
  refetchEvent,
  createDraft,
  setOffersStep
}) => (
  <FadeIn>
    <div
      className="pt-[90px] md:pt-[180px] -mt-[90px] pb-20 md:w-[630px] md:mx-auto px-4 "
      onClick={async () => {
        // Create a draft if event has not been created yet
        if (!eventId) {
          await createDraft();
        }
      }}
    >
      <h3 className="text-lg font-semibold">Guest</h3>
      <WaiverSetting refetchEvent={refetchEvent} />
      <GuestQuestionSetting />

      <h3 className="mt-6 text-lg font-semibold">Analytics</h3>
      <TrackingLinksSettings
        eventId={eventId}
        navigateToTrackingLinks={navigateToTrackingLinks}
      />
      <DiscountCodesSettings
        eventId={eventId}
        navigateToDiscountCodes={navigateToDiscountCodes}
      />
      <OffersSettings
        eventId={eventId}
        navigateToOffers={navigateToOffers}
        setOffersStep={setOffersStep}
      />
      <MetaPixelSettings />

      <h3 className="mt-6 text-lg font-semibold">Advanced options</h3>
      <MaxTicketsSettings />
      <MaxCapacitySettings />
      <TaxSettings />
      <EventOrganizerFee />

      <MomentSettings />

      {eventId && (
        <DangerZone
          eventId={eventId}
          navigateToSeriesSettings={navigateToSeriesSettings}
        />
      )}
    </div>
  </FadeIn>
);

export default EventSettings;
